import { ICertificationAssetDto, ICertifiedByDto, IUpdatedByDto } from './certification-output-dto.interface';
import { OrderMeasuresTypes } from '../enums';

export interface IItemCertificationDto {
    type: OrderMeasuresTypes;
    value: number;
}

export interface IOrderCertificationDto {
    type: OrderMeasuresTypes;
    value: number;
}

export interface ICertificationItemsDto {
    orderItemId: string;
    certifications: IItemCertificationDto[];
    subStatus?: string;
    /** True when the weight was corrected manually; otherwise the delivered weight is inferred from the quantity */
    weightEdited?: boolean;
}

export interface ICertificationReferenceDto {
    order?: string;
    trip?: string;
    checkpointIndex?: number;
}

export interface ISubstatusDto {
    //id: string;
    value: string;
}

export interface ICreateCertificationDto {
    level: string;
    ref: ICertificationReferenceDto;
    certifiedAt: string;
    certifiedBy?: ICertifiedByDto;
    status: string;
    subStatus?: ISubstatusDto;
    photos?: ICertificationAssetDto[];
    signatures?: ICertificationAssetDto[];
    comments?: Omit<ICertificationAssetDto, 'url'>[];
    items?: ICertificationItemsDto[];
    orderMeasures?: IOrderCertificationDto[];

    updatedBy?: IUpdatedByDto;

    /** Version of the driver app that produced the certification (e.g. "1.0.40+72"); absent for web. */
    appVersion?: string;
}
